module.exports = {
	"151": {
		"pos": [
			0,
			3
		]
	},
	"325": {
		"pos": [
			0,
			0
		],
		"name": "Новомосковский АО"
	},
	"326": {
		"pos": [
			0,
			1
		],
		"name": "Троицкий АО"
	},
	"nw": {
		"pos": [
			1,
			0
		]
	},
	"w": {
		"pos": [
			1,
			1
		]
	},
	"sw": {
		"pos": [
			1,
			2
		]
	},
	"n": {
		"pos": [
			2,
			0
		]
	},
	"center": {
		"pos": [
			2,
			1
		]
	},
	"s": {
		"pos": [
			2,
			2
		]
	},
	"ne": {
		"pos": [
			3,
			0
		]
	},
	"e": {
		"pos": [
			3,
			1
		]
	},
	"se": {
		"pos": [
			3,
			2
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/components/district-browser/src/scripts/moscow-districts.json
// module id = 286
// module chunks = 0